import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../shared/components/data-listing-provider/data-listing-provider.component';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ModuleId } from '../../../shared/store/navigation/types';
import { CashJournalDetailsComponent } from './cash-journal-details/cash-journal-details.component';
import { CashControlComponent } from './cash-control/cash-control.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';

const routes: Routes = [
  {
    path: 'Finance/CashJournals',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CashJournal,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        data: {
          breadcrumb: { label: ' ', alias: 'cashJournalDetails' },
        },
        children: [
          {
            path: '',
            component: CashJournalDetailsComponent,
            canActivate: [AuthenticationGuard],
            canDeactivate: [HasUnsavedChangesGuard],
            data: {
              headerMenu: HeaderMenuType.Finance,
              moduleId: ModuleId.finance,
              entity: Entity.CashJournal,
              breadcrumb: { label: ' ', alias: 'cashJournalDetails' },
            },
          },
          {
            path: 'Control',
            component: CashControlComponent,
            canActivate: [AuthenticationGuard],
            canDeactivate: [HasUnsavedChangesGuard],
            data: {
              headerMenu: HeaderMenuType.Finance,
              moduleId: ModuleId.finance,
              entity: Entity.CashJournal,
              breadcrumb: { label: 'Contrôle de caisse' },
            },
          },
        ],
      },

      // {
      //   path: 'Create',
      //   component: CommissionPlanRuleCompanyCreateComponent,
      //   canActivate: [AuthentificationGuard],
      //   canDeactivate: [HasUnsavedChangesGuard],
      //   data: {
      //     headerMenu: HeaderMenuType.Finance,
      //     moduleId: ModuleId.finance,
      //     entity: Entity.CommissionPlanRuleCompany,
      //     breadcrumb: { label: ' ', alias: 'commissionPlanRuleCompanyCreate' },
      //   },
      // },
      // {
      //   path: 'Edit/:id',
      //   component: CommissionPlanRuleCompanyEditComponent,
      //   canActivate: [AuthentificationGuard],
      //   canDeactivate: [HasUnsavedChangesGuard],
      //   data: {
      //     headerMenu: HeaderMenuType.Finance,
      //     moduleId: ModuleId.finance,
      //     entity: Entity.CommissionPlanRuleCompany,
      //     breadcrumb: { label: ' ', alias: 'commissionPlanRuleCompanyEdit' },
      //   },
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CashJournalRoutingModule {}
